import './style.scss';

export default function () {
    'ngInject';
}



// WEBPACK FOOTER //
// ./src/app/views/app/index.js